module.exports = __webpack_public_path__ + "media/images/vehicles/kipper-5160038cfe39caadecbe785b69b90016.png";